import React from 'react';

/**
 * Honeypot input — invisible to humans (off-screen, skipped by tab order and
 * screen readers) but present in the DOM, so form-filling bots populate it.
 * The server rejects any submission where this field arrives non-empty.
 * Field name must stay in sync with HONEYPOT_FIELD in src/middleware/botGuard.js.
 */
function HoneypotField({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden',
      }}
    >
      <label htmlFor="website">Website</label>
      <input
        type="text"
        id="website"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default HoneypotField;
